import type { PropsWithChildren } from 'react';
import { FilterDevice } from './filter-device';
import { FilterPage } from './filter-page';
import { FilterTime } from './filter-time';
import { FilterUser } from './filter-user';

export function Filters({ children }: PropsWithChildren) {
  return (
    <FilterPage>
      <FilterDevice>
        <FilterTime>
          <FilterUser>{children}</FilterUser>
        </FilterTime>
      </FilterDevice>
    </FilterPage>
  );
}
